import React from "react";
import { NextPage } from "next";
import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { recommendationSlice } from "@common/redux/slices/recommendation.slice";
import { Layout } from "@kursk/components/Layout/Layout";
import { placesListSlice } from "@common/redux/slices/places.slice";
import { HeaderBlock } from "@kursk/components/ui/HeaderBlock/HeaderBlock";
import { ContentBlock } from "@kursk/components/ui/ContentBlock/ContentBlock";
import { SocialLinks } from "@kursk/components/ui/SocialLinks/SocialLinks";
import { Tags } from "@kursk/components/ui/Tags/Tags";
import { RecommendationsBlock } from "@kursk/components/ui/RecommendationsBlock/RecommendationsBlock";
import { Socials } from "@kursk/components/pages/Home/Socials/Socials";
import { ContactsBlock } from "@kursk/components/ui/ContactsBlock/ContactsBlock";
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";
import { LdJson } from "@kursk/components/seo/LdJson";
import styles from "./SinglePlace.module.scss";
import { getAddress } from "@kursk/utils/getAddress";
import { FeedbacksBlock } from "@kursk/components/ui/FeedbacksBlock/FeedbacksBlock";
import { getConfig } from "@root/config/config";
import { AudioBlock } from "@kursk/components/ui/AudioBlock/AudioBlock";
import { AudioProvider } from "@kursk/context/audio.context";

export const SinglePlace: NextPage = () => {
  const { place } = useSelectSlice(placesListSlice);
  const { forPlacesEvents, forPlacesStreams, forPlacesPlaces } = useSelectSlice(recommendationSlice);

  if (!place) {
    return <></>;
  }
  return (
    <Layout key={`place_${place._id}`}>
      <AudioProvider>
        <>
          <LdJson
            entity={place}
            type={'places'}
          />
          <SeoMetaTitles page="singlePlace" entity={{
            name: place.name,
            seo: place.seo,
            image: place.image,
            address: getAddress(place.address),
          }} showOgImage={true}/>
          <section className={styles.place_header}>
            <HeaderBlock
              entityType={'places'}
              entity={place}
              goBack={'/places'}
              goBackTitle={'вернуться к списку мест'}/>
          </section>
          <section className={styles.entity_share}>
            <SocialLinks/>
          </section>
          {place.audio && place.audio.length > 0 && (
            <section className={styles.entity_audio}>
              {place.audio.map((audio, index) => {
                return audio ? (
                  <AudioBlock className={styles.entity_audio_row} key={`audio_${audio.name}_${index}`} audio={audio}/>
                ) : null;
              })}
            </section>
          )}
          <section className={styles.entity_content}>
            <ContentBlock content={place.content} source={place?.source}/>
          </section>
          <section className={styles.entity_contacs}>
            <ContactsBlock entity={place}/>
          </section>
          <section className={styles.entity_tags}>
            <Tags link={'/places'} className={styles.tags} tags={place?.tags}/>
          </section>
          <section className={styles.entity_feedbacks}>
            <FeedbacksBlock entity={place} entityType={'places'}/>
          </section>
          <section className={styles.entity_recommendations}>
            <RecommendationsBlock
              entityType="events"
              data={forPlacesEvents}
              title={'события в этом месте'}
              goTo={'/events'}
              goToTitle={'все события'}/>
          </section>
          <section className={styles.entity_recommendations}>
            <RecommendationsBlock
              entityType="streams"
              data={forPlacesStreams}
              title={'трансляции в этом месте'}
              goTo={'/streams'}
              goToTitle={'все трансляции'}
              newTab={getConfig().liveRedirect.enabled}
            />
          </section>
          <section className={styles.entity_recommendations}>
            <RecommendationsBlock
              entityType="places"
              data={forPlacesPlaces}
              title={'также рекомендуем'}
              goTo={'/places'}
              goToTitle={'все места'}/>
          </section>
          <section className={styles.entity_social}>
            <Socials/>
          </section>
        </>
      </AudioProvider>
    </Layout>
  )
}
